"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trialStateAdapter = void 0;

var _Trials = require("self-service-api/constants/Trials");

var _trialUtils = require("self-service-api/core/utilities/trialUtils");

var _UpgradeProducts = require("self-service-api/constants/UpgradeProducts");

var trialStateAdapter = function trialStateAdapter(trialState) {
  if (trialState.length === 0) return trialState;
  var transformedTrialState = {};
  trialState.forEach(function (hubTrial) {
    var trials = hubTrial.trials,
        createdAt = hubTrial.createdAt,
        endsAt = hubTrial.endsAt,
        removedAt = hubTrial.removedAt;
    trials.forEach(function (trial) {
      var name = trial.name,
          id = trial.id; //Temporary since covid remote tools trial does not have a merch id

      var label;

      if (name === 'temp-covid-relief-trial') {
        label = _UpgradeProducts.TEMPORARY_REMOTE_TOOLS;
      } else {
        label = _Trials.upgradeProductToMerchIds[name];
      }

      transformedTrialState[label] = (0, _trialUtils.buildTrialState)(createdAt, endsAt, removedAt, id);
    });
  });
  return transformedTrialState;
};

exports.trialStateAdapter = trialStateAdapter;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/adapters/trialStateAdapter.js
// module id = 765
// module chunks = 5 6